import { useCallback, useEffect } from 'react';
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/react';
import { ClickAwayListener } from '@mui/material';
import { useLinkModalContext, useLinkPopperContext } from './Context';
import { FloatingWrapper } from './FloatingWrapper';
import { useLinkPositioner } from './hooks/useLinkPositioner';
import { useRemoveLink } from './hooks/useRemoveLink';
import { LinkExtensionPopper } from './Link.Popper';

export const LinkPopperContainer = (props: ChildrenProps) => {

  const {
    open: openModal,
  } = useLinkModalContext();
  const {
    selection: popperSelection,
    close: closePopper,
  } = useLinkPopperContext();

  const handleRemove = useRemoveLink();

  const position = useLinkPositioner();

  const { refs, floatingStyles } = useFloating({
    open: Boolean(popperSelection),
    placement: 'bottom-start',
    middleware: [offset(4), flip(), shift()],
    whileElementsMounted: autoUpdate,
  });

  useEffect(() => {
    if (position.element) {
      refs.setReference(position.element);
    }
  }, [position.element, refs]);

  const handleCancel = useCallback(() => {
    closePopper();
  }, [closePopper]);

  const handleEdit = useCallback(() => {
    openModal(popperSelection);
    closePopper();
  }, [closePopper, openModal, popperSelection]);

  return (
    <>
      <FloatingWrapper
        renderOutsideEditor={true}
        position={position}>
        <div
          ref={refs.setFloating}
          style={{ ...floatingStyles, zIndex: 10 }}>
          {position.active &&
            <ClickAwayListener onClickAway={closePopper}>
              <LinkExtensionPopper
                key={popperSelection?.text}
                href={popperSelection?.href}
                text={popperSelection?.text}
                onCancel={handleCancel}
                onClickEdit={handleEdit}
                onRemove={handleRemove} />
            </ClickAwayListener>
          }
        </div>
      </FloatingWrapper>
      {props.children}
    </>
  );
};
